import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';

export class RadioSetAdapter extends TestAdapter {
  /**
   * Change the value of the component.
   * @param value {string | number} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: number | string) {
    const driver = this.getTestDriver();
    const el = await this.getElement();
    const labels = await el.waitForElements(byCss(`div[role="radiogroup"] label:not([for])`));

    await Promise.all(
      labels.map(async (label) => {
        const input = await label.waitForElement(byCss('input[type="radio"]'));
        const inputValue = await input.getAttribute('value');

        if (value == inputValue) {
          await driver.click(label);
        }
      })
    );
  }
}
